import { LineClamp } from "@newsela/angelou";
import PropTypes from "prop-types";

import getLevelDisplayValues from "@/assignments/utils/getLevelDisplayValues";

const propTypes = {
  level: PropTypes.object,
};

const LevelItem = ({ level }) => {
  // No level means that the article loads at the default level for each user.
  const text = "Newsela recommended Lexile Level®";
  if (!level) {
    return <LineClamp text={text} lines={1} />;
  }

  const { formattedGrade, lexileRange } = getLevelDisplayValues(level);

  return (
    <>
      <span>{formattedGrade} </span>
      <span>{lexileRange}</span>
    </>
  );
};

LevelItem.propTypes = propTypes;

export default LevelItem;
